(function () {
  if (window.__elixivaStickySubscribeLoaded) return;
  window.__elixivaStickySubscribeLoaded = true;

  var BAR_SELECTOR = '[data-elixiva-sticky-cart]';
  var MAIN_SELECTOR = '#MainContent';

  function getBar() {
    return document.querySelector(BAR_SELECTOR);
  }

  function getMain() {
    return document.querySelector(MAIN_SELECTOR);
  }

  function getProductForm(bar) {
    var main = getMain();
    if (!main || !bar) return null;

    var productId = String(bar.dataset.productId || '');
    var components = Array.from(main.querySelectorAll('product-form-component'));
    var component = components.find(function (item) {
      return String(item.dataset.productId || '') === productId;
    }) || components[0];

    if (component) {
      return component.querySelector('form[data-type="add-to-cart-form"]') || component.querySelector('form[action*="/cart/add"]') || component.querySelector('form');
    }

    return main.querySelector('form[action*="/cart/add"]');
  }

  function nonEmpty(value) {
    return String(value || '').trim() !== '';
  }

  function selectedPlanValue(root) {
    if (!root || !root.querySelectorAll) return '';

    var selects = Array.from(root.querySelectorAll('select[name="selling_plan"]'));
    for (var i = 0; i < selects.length; i += 1) {
      var selected = selects[i].options && selects[i].options[selects[i].selectedIndex];
      if (selected && nonEmpty(selected.value)) return String(selected.value);
    }

    var checked = root.querySelector('input[type="radio"][name="selling_plan"]:checked');
    if (checked && nonEmpty(checked.value)) return String(checked.value);

    var otherInputs = Array.from(root.querySelectorAll('input[name="selling_plan"]:not([type="radio"])'));
    var valued = otherInputs.find(function (input) { return nonEmpty(input.value); });
    return valued ? String(valued.value) : '';
  }

  function firstAvailablePlanValue(root) {
    if (!root || !root.querySelectorAll) return '';

    var selects = Array.from(root.querySelectorAll('select[name="selling_plan"]'));
    for (var i = 0; i < selects.length; i += 1) {
      var option = Array.from(selects[i].options || []).find(function (item) {
        return nonEmpty(item.value);
      });
      if (option) return String(option.value);
    }

    var radio = Array.from(root.querySelectorAll('input[type="radio"][name="selling_plan"]')).find(function (item) {
      return nonEmpty(item.value);
    });
    return radio ? String(radio.value) : '';
  }

  function preferredPlanValue(bar, form) {
    var current = selectedPlanValue(form) || selectedPlanValue(getMain());
    if (current) return current;

    var liquidPlanId = String(bar.dataset.subscriptionPlanId || '').trim();
    if (liquidPlanId) return liquidPlanId;

    return firstAvailablePlanValue(form) || firstAvailablePlanValue(getMain());
  }

  function setControlValue(control, value) {
    var changed = false;

    if (control.tagName === 'SELECT') {
      var hasValue = Array.from(control.options || []).some(function (option) {
        return String(option.value) === String(value);
      });
      if (!hasValue) return false;
      if (String(control.value) !== String(value)) {
        control.value = value;
        changed = true;
      }
    } else if (control.type === 'radio') {
      var shouldCheck = String(control.value) === String(value);
      if (control.checked !== shouldCheck) {
        control.checked = shouldCheck;
        changed = true;
      }
      if (!shouldCheck) return false;
    } else {
      if (String(control.value) !== String(value)) {
        control.value = value;
        changed = true;
      }
    }

    if (changed) {
      control.dispatchEvent(new Event('input', { bubbles: true }));
      control.dispatchEvent(new Event('change', { bubbles: true }));
    }

    return true;
  }

  function forceSubscription(bar) {
    if (!bar || !bar.dataset.subscriptionPlanId) return false;

    var form = getProductForm(bar);
    if (!form) return false;

    var value = preferredPlanValue(bar, form);
    if (!value) return false;

    var main = getMain();
    if (main) {
      Array.from(main.querySelectorAll('[name="selling_plan"]')).forEach(function (control) {
        setControlValue(control, value);
      });
    }

    var successfulInForm = Array.from(form.querySelectorAll('[name="selling_plan"]')).some(function (control) {
      if (control.tagName === 'SELECT') return String(control.value) === String(value);
      if (control.type === 'radio') return control.checked && String(control.value) === String(value);
      return String(control.value) === String(value);
    });

    if (!successfulInForm) {
      var hidden = form.querySelector('input[data-elixiva-sticky-subscription]');
      if (!hidden) {
        hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'selling_plan';
        hidden.dataset.elixivaStickySubscription = 'true';
        form.appendChild(hidden);
      }
      hidden.value = value;
    }

    return true;
  }

  function enforceStickySubscriptionUi(bar) {
    if (!bar || !bar.dataset.subscriptionPlanId) return;

    var button = bar.querySelector('[data-elixiva-sticky-submit]');
    var text = bar.querySelector('[data-elixiva-sticky-button-text]');
    var priceMain = bar.querySelector('[data-elixiva-sticky-price]');
    var priceButton = bar.querySelector('[data-elixiva-sticky-button-price]');
    var planWrap = bar.querySelector('[data-elixiva-sticky-plan-wrap]');
    var subscriptionPrice = String(bar.dataset.subscriptionPrice || '').trim();

    if (planWrap && !planWrap.hidden) planWrap.hidden = true;

    if (button && !button.disabled && text && text.textContent.trim() !== 'Suscribirse') {
      text.textContent = 'Suscribirse';
    }

    if (subscriptionPrice) {
      if (priceMain && priceMain.textContent.trim() !== subscriptionPrice) priceMain.textContent = subscriptionPrice;
      if (priceButton && priceButton.textContent.trim() !== subscriptionPrice) priceButton.textContent = subscriptionPrice;
    }
  }

  function boot() {
    var bar = getBar();
    if (!bar || !bar.dataset.subscriptionPlanId) return;

    enforceStickySubscriptionUi(bar);

    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!(target instanceof Element)) return;
      var button = target.closest('[data-elixiva-sticky-submit]');
      if (!button || !bar.contains(button)) return;
      forceSubscription(bar);
    }, true);

    if (window.MutationObserver) {
      var observer = new MutationObserver(function () {
        enforceStickySubscriptionUi(bar);
      });
      observer.observe(bar, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['disabled', 'hidden']
      });
    }

    document.addEventListener('variant:update', function () {
      window.setTimeout(function () {
        enforceStickySubscriptionUi(bar);
      }, 0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
